// extracted by css-extract-rspack-plugin
export default {"label-sort":"LabelSortMagritte-module__label-sort--gWgXp","labelSort":"LabelSortMagritte-module__label-sort--gWgXp"};